import { AddTheme } from "utils";

import * as calandar from "./theme/ComponentThemes/Calandar.scss";

AddTheme("REDI_Calender", calandar, {
	dayClass: "calender-day"
});
